import { render, staticRenderFns } from "./ThirdBlock.vue?vue&type=template&id=80e40efa&scoped=true"
import script from "./ThirdBlock.vue?vue&type=script&lang=js"
export * from "./ThirdBlock.vue?vue&type=script&lang=js"
import style0 from "./ThirdBlock.vue?vue&type=style&index=0&id=80e40efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e40efa",
  null
  
)

export default component.exports